import type {
  CreateOrganisationNormalisedResponse,
  CreateOrganisationResponse,
} from './organisations.module.types'

export const handleSuccess = (
  response: CreateOrganisationResponse,
): CreateOrganisationNormalisedResponse => ({
  id: response.id,
  name: response.name,
})
